import {get} from 'lodash';

import {SearchResultItem} from './search_result_item';

const CASE_TYPES_EMBEDDED = '_embedded';
const CASE_TYPES = 'caseTypes';

const CASE_TYPE_ID = 'id';
const CASE_TYPE_NAME = 'name';

const CASE_TYPE_PROPERTIES = 'properties';
const CASE_TYPE_ICON = 'icon';
const CASE_TYPE_MESSAGE = 'message';

const CASE_HIERARCHY = 'hierarchy';
const CASE_HIERARCHY_NAME = 'name';
const CASE_HIERARCHY_LABEL = 'label';
const CASE_PROJECT_PROPERTIES = 'properties';
const CASE_PROJECT_PROPERTY_TYPE_NAME = 'typeName';
const CASE_PROJECT_PROPERTY_VALUE = 'value';
const CASE_ID = 'id';
const CASE_NAME = 'name';
const CASE_SUBTITLE = 'subtitle';
const CASE_TYPE = 'type';

const DEFAULT_CASE_TYPE_NAME = 'Documents';
const DEFAULT_CASE_TYPE_MESSAGE = 'caseType.documents';

export class CaseType {
  constructor(
    rawData = {[CASE_ID]: undefined, [CASE_TYPE_NAME]: DEFAULT_CASE_TYPE_NAME}
  ) {
    this.rawData = {...rawData};
    this.properties = {};
    if (rawData[CASE_TYPE_PROPERTIES]) {
      this.properties = {
        ...rawData[CASE_TYPE_PROPERTIES][CASE_TYPE_PROPERTIES],
      };
    }
  }

  getId() {
    return this.rawData[CASE_TYPE_ID];
  }

  getRawData() {
    return this.rawData;
  }

  getName() {
    return this.rawData[CASE_TYPE_NAME];
  }

  getIcon() {
    return this.properties[CASE_TYPE_ICON];
  }

  getMessage() {
    return this.properties[CASE_TYPE_MESSAGE];
  }

  getProperties() {
    return this.properties;
  }

  getOptionsProjection() {
    return {
      value: this.getId(),
      label: this.getName(),
    };
  }
}

export class CaseTypes {
  static initCaseTypes(rawDataCaseTypes) {
    const caseTypes = [];
    if (rawDataCaseTypes) {
      rawDataCaseTypes.forEach((caseType) => {
        caseTypes.push(new CaseType(caseType));
      });
    }
    return caseTypes;
  }

  constructor(rawData = {}, addEmpty = false) {
    this.rawData = {...rawData};
    this.loaded = false;
    if (this.rawData && this.rawData[CASE_TYPES_EMBEDDED]) {
      this.caseTypes = CaseTypes.initCaseTypes(
        this.rawData[CASE_TYPES_EMBEDDED][CASE_TYPES]
      );
      if (addEmpty) {
        this.caseTypes.unshift(
          new CaseType({
            [CASE_ID]: undefined,
            [CASE_TYPE_NAME]: DEFAULT_CASE_TYPE_NAME,
            [CASE_TYPE_PROPERTIES]: {
              [CASE_TYPE_PROPERTIES]: {
                [CASE_TYPE_MESSAGE]: DEFAULT_CASE_TYPE_MESSAGE,
              },
            },
          })
        );
      }
      this.loaded = true;
    }
  }

  getRawData() {
    return this.rawData;
  }

  isLoaded() {
    return this.loaded;
  }

  getItems() {
    return this.caseTypes;
  }
}

export class Case extends SearchResultItem {
  static initCaseType(rawDataCaseType) {
    return new CaseType(rawDataCaseType);
  }

  static initProjectPropertiesMap(rawDataProperties) {
    const projectProperties = {};
    if (rawDataProperties) {
      rawDataProperties.forEach((property) => {
        projectProperties[property[CASE_PROJECT_PROPERTY_TYPE_NAME]] =
          property[CASE_PROJECT_PROPERTY_VALUE];
      });
    }
    return projectProperties;
  }

  constructor(rawData = {}) {
    super();
    this.rawData = {...rawData};
    this.caseType = Case.initCaseType(this.rawData[CASE_TYPE]);
    this.projectProperties = Case.initProjectPropertiesMap(
      this.rawData[CASE_PROJECT_PROPERTIES]
    );
  }

  getId() {
    return this.rawData[CASE_ID];
  }

  getRawData() {
    return this.rawData;
  }

  getCaseType() {
    return this.caseType;
  }

  getProjectProperties() {
    return this.projectProperties;
  }

  getProjectProperty(propertyName) {
    let value;
    if (propertyName.indexOf('.') !== -1) {
      value = get(this.getProjectProperties(), propertyName);
    } else {
      value = this.getProjectProperties()[propertyName];
    }
    return value;
  }

  getTitle() {
    return this.getName();
  }

  getSubTitle() {
    return this.getProjectProperty(CASE_SUBTITLE);
  }

  getName() {
    const caseHierarchy = this.rawData[CASE_HIERARCHY];
    return caseHierarchy && caseHierarchy[CASE_HIERARCHY_NAME]
      ? caseHierarchy[CASE_HIERARCHY_LABEL] ||
          caseHierarchy[CASE_HIERARCHY_NAME]
      : this.rawData[CASE_NAME];
  }

  getTableProjection(metadata = {}) {
    return {
      ...this.getRawData(),
      ...metadata,
    };
  }

  getProperty(propertyName) {
    let value;
    if (propertyName.indexOf('.') !== -1) {
      value = get(this.rawData, propertyName);
    } else {
      value = this.rawData[propertyName];
    }
    return value;
  }
}

export default {Case, CaseTypes, CaseType};
